export default "__VITE_ASSET__CBN8siK0__"